var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function template() {
  var $body = $( "body" ), template;

  function hasClass( templateName ) {
    return $body.hasClass( templateName );
  }

  if ( hasClass( "page-landing" ) ) {
    template = "landing";
  } else if ( hasClass( "single-event" ) ) {
    template = "event";
  } else if ( hasClass( "page-calendar" ) ) {
    template = "calendar";
  }
}

module.exports = template;
